// Biblioteca de planilha (SheetJS) carregada só na hora de importar/exportar
// (2026-10-05). Importada direto, ela ia inteira no arquivo principal do app
// (~410 KB de 1,4 MB) — todo mundo baixava no boot, e no iPhone com rede
// fraca a tela do carrinho ficava 20–30 s esperando. Nunca importe "xlsx"
// estaticamente: use loadXlsx() (tipos podem vir com `import type`).
let xlsxPromise: Promise<typeof import("xlsx")> | null = null;

export function loadXlsx(): Promise<typeof import("xlsx")> {
  if (!xlsxPromise) {
    xlsxPromise = import("xlsx").catch((err) => {
      // Falha de rede: permite tentar de novo no próximo clique.
      xlsxPromise = null;
      throw err;
    });
  }
  return xlsxPromise;
}
